import React, {useEffect, useState, useRef} from "react";
import InitializePage from '../../lib/server/page'
import Link from "next/link"
import { Modal } from 'antd';
import { useRouter } from 'next/router'

import Header from "../../components/Layouts/Header";
import HomeFooter from '../../components/Layouts/HomeFooter.jsx';
import SubscribeNewsLetter from '../../components/common/subscribenewsletter.jsx';
import PdfViewer from "../../components/PdfViewer";
import HeaderTag from '../../components/meta.jsx';

import { getHomeCommunicadosBydetail } from "../../lib/api/home.jsx";
import OtherReleases from "../../components/ContentListing/OtherReleases";
import VideoContent from "../../components/ContentDetails/VideoContent";

const Contendos = (props) => {
	const {webTexts} = props;
  	const communicados = props?.resp?.data ? props?.resp?.data : [];
  	const pdfUrl = props?.resp?.data?.pdfUrl ? true : false;
  	const [isModalVisible, setisModalVisible] = useState(false);
  	const ref = useRef();
	const router = useRouter();
	
	useEffect(() => {
		const checkIfClickedOutside = (e) => {
				if (isModalVisible && ref.current && !ref.current.contains(e.target)) {
				setisModalVisible(false);
				}
			};

			document.addEventListener("mousedown", checkIfClickedOutside);

			return () => {
				document.removeEventListener("mousedown", checkIfClickedOutside);
			};
		}, [isModalVisible]);

  return (
    <>
        <Header page={'common'} menuSections={props.menu}/>
        <HeaderTag title="Eccediciones" description="eccediciones" url={`${props.host}${router.asPath.split('?')[0]}`} />
        <div className="container main-container communicados">
            <div className="innerpage-2">
                <h2 className="communicadostitle">{communicados?.title}</h2>
                <div className="line4"></div>
                <h6 className={pdfUrl?"subheading f-left w-70":"subheading f-left"} dangerouslySetInnerHTML={{ __html:communicados?.shortContent}}></h6>
                {pdfUrl
                ?
                <>
                <div className="pdf-btn-div">
                    <a  href={process.env.NEXT_PUBLIC_PATH + communicados?.pdfUrl} className="pdf-btn" target="_blank" rel="noreferrer" >Ver comunicado completo</a>
                    <br/>
                    <a href={`/api/getPdf?file=${process.env.NEXT_PUBLIC_PATH + communicados?.pdfUrl}`} download className="pdf-btn">Descargar comunicado</a>
                </div>
                </>
                : ""}
                <div className="clearfix"></div>
            </div>
        </div>
        <div className="main-container container">
            <div className="innerpage-2 communicados ck-content" dangerouslySetInnerHTML={{ __html:communicados?.extendedContent}}>                
            </div>
            <VideoContent videoUrl={communicados?.video} videoWidth={communicados?.videoWidth}/>
        </div>
        <div className="clearfix"></div>
        {communicados?.contentTypeId == 1 && <OtherReleases></OtherReleases>}
        <div className="clearfix"></div>
        <div className="container line-container">
            <div className="line6"></div>
        </div>
        <SubscribeNewsLetter webTexts={webTexts}/>
        <div className="wrapper" ref={ref}>
            <Modal visible={isModalVisible} className="pdfModal" handleCancel={() => setisModalVisible(!isModalVisible)} onBlur={() => setisModalVisible(!isModalVisible)}>
                <PdfViewer
                    pdfUrlpath={process.env.NEXT_PUBLIC_PATH}
                    communicadosUrl={communicados?.pdfUrl}
                />
            </Modal>
        </div>
        <HomeFooter />
    </>
  );
};

async function loadData(context){             
    const data = {
      "slug": context?.query?.slug,
      "tokenId": context?.query?.token || '',
    }
    const resp = await getHomeCommunicadosBydetail(data);

    return {resp: resp || null}
}

export async function getServerSideProps(context) {    
    return InitializePage(context,loadData, false)
}

export default Contendos;
